import { Location } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Actions, ofActionSuccessful, Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { PermitRequest } from "../../../shared/models/permit-request.model";
import { PermitUserActions } from "../../../shared/states/permit-user.action";
import { PermitUserSelectors } from "../../../shared/states/permit-user.selectors";

@UntilDestroy()
@Component({
    selector: "pmt-permit-request-list",
    templateUrl: "./permit-request-list.component.html",
    styleUrls: ["./permit-request-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitRequestListComponent implements OnInit {
    @Select(PermitUserSelectors.permitRequests)
    public permitRequests$!: Observable<PermitRequest[]>;

    @Select(PermitUserSelectors.loading)
    public loading$!: Observable<boolean>;

    constructor(private store: Store, private location: Location, private actions$: Actions) {}

    public ngOnInit(): void {
        this.store.dispatch(new PermitUserActions.GetCurrentPerson());
        this.actions$.pipe(untilDestroyed(this), ofActionSuccessful(PermitUserActions.GetCurrentPerson)).subscribe(
            () => {
                this.store.dispatch(new PermitUserActions.GetPermitRequests());
            },
        );
    }

    public refresh(): void {
        this.store.dispatch(new PermitUserActions.GetPermitRequests());
    }

    public cancel(): void {
        this.location.back();
    }
}
